(() => {
  'use strict';
  const panel = document.getElementById('lavb-post-add-accessories');
  // Native booth/GPO add flows remain untouched. This step starts only at cart Checkout.
  window.LAVBPostAddAccessories = {offer: () => false};
  if (!panel || panel.dataset.cartPage !== 'true') return;
  const isStep = panel.dataset.accessoryStep === 'true';
  const signature = panel.dataset.boothSignature || '';
  const key = 'lavb-accessory-step-completed-v2';
  const root = window.Shopify?.routes?.root || '/';
  const status = panel.querySelector('[role="status"]');
  const cards = [...panel.querySelectorAll('[data-variant-id]')];
  let busy = false;
  const completed = () => {try {return sessionStorage.getItem(key) === signature;} catch(e) {return false;}};
  const finish = () => {try {sessionStorage.setItem(key,signature);} catch(e) {}};
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:panel.dataset.currency || 'USD'}).format(cents/100);
  async function refreshCard(card) {
    const button = card.querySelector('[data-accessory-add]');
    button.disabled = true; button.textContent = 'Checking availability…';
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(card.dataset.handle)}.js`,{credentials:'same-origin'});
      if (!response.ok) throw new Error('Product information is unavailable.');
      const product = await response.json();
      const variant = product.variants.find(v=>String(v.id)===card.dataset.variantId);
      if (!variant) throw new Error('This item is currently unavailable.');
      card.querySelector('.lavb-upsell__price').textContent = money(variant.price);
      card.querySelector('.lavb-upsell__availability').textContent = variant.available ? 'Available' : 'Sold out';
      button.disabled = !variant.available; button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
    } catch(error) {button.textContent='Unavailable';card.querySelector('.lavb-upsell__error').textContent=error.message;}
  }
  function initialize() {status.textContent='';cards.forEach(refreshCard);}
  if (isStep) initialize();
  document.addEventListener('submit',event=>{
    if (event.target.matches('[data-upsell-final]')) {
      if (busy) event.preventDefault(); else finish();
      return;
    }
    if (isStep || event.submitter?.name !== 'checkout' || !signature || completed()) return;
    if (!event.target.matches('form[action$="/cart"]')) return;
    event.preventDefault();
    const params = new URL(location.href).searchParams;
    if (params.get('lavb_upsell') === 'popup' && typeof panel.showModal === 'function') {
      panel.showModal();panel.querySelector('h2').focus();initialize();
    } else {
      const url = new URL(`${root}cart`,location.origin);url.searchParams.set('view','accessories');
      if(params.has('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
      window.location.assign(url.href);
    }
  },true);
  panel.addEventListener('cancel',event=>{if(busy)event.preventDefault();});
  panel.addEventListener('click',async event=>{
    const button=event.target.closest('[data-accessory-add]');
    if(!button || button.disabled || busy)return;
    const card=button.closest('[data-variant-id]'),input=card.querySelector('input');
    if(!input.reportValidity())return;
    const quantity=Number(input.value);if(!Number.isInteger(quantity)||quantity<1||quantity>99)return;
    busy=true;button.disabled=true;button.textContent='Adding…';panel.setAttribute('aria-busy','true');
    const finals=[...panel.querySelectorAll('[data-upsell-final] button')];finals.forEach(b=>b.disabled=true);
    const errorBox=card.querySelector('.lavb-upsell__error');errorBox.textContent='';
    try {
      const response=await fetch(`${root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(card.dataset.variantId),quantity}]})});
      const result=await response.json();
      if(!response.ok||result.status||result.errors)throw new Error(result.description||'Could not add this accessory. Please try again.');
      button.textContent='Added';status.textContent=`${quantity} × ${card.querySelector('h3').textContent.trim()} added. Add another accessory or continue to checkout.`;
    } catch(error) {errorBox.textContent=error.message;button.disabled=false;button.textContent='Add to Cart';}
    finally {busy=false;panel.removeAttribute('aria-busy');finals.forEach(b=>b.disabled=false);}
  });
})();
